module.exports = __webpack_public_path__ + "src/assets/games/4/qiao1.png";